import { useIntakeFormUI } from '@/components/IntakeFormProvider';
import { isFetchBaseQueryError } from '@/redux/slices/helpers/errorHandlersHelpers';
import { useAppSelector } from '@/redux/store';
import { OrganizationUserRoleSlugs } from '@/types/users';
import { useGetOrganizationIntakeFormQuery } from '@/redux/slices/organizationApiSlice';
import { useOrganizationHasEntitlement } from '@/hooks/useOrganizationHasEntitlement';
import { EntitlementSlugEnum } from '@electricjs/core_entity-client';
import { skipToken } from '@reduxjs/toolkit/query';

export const useIntakeSurvey = () => {
  const { showIntakeForm } = useIntakeFormUI();

  const organizationId = useAppSelector(
    state => state.loggedUser?.organizationId
  );

  // Add a skip if organizationId is not available
  const { error } = useGetOrganizationIntakeFormQuery(
    organizationId
      ? {
          organizationId: organizationId as string,
        }
      : skipToken
  );

  const loggedUser = useAppSelector(state => state.loggedUser);
  const isAdminRole = loggedUser?.organizationUserRoles?.some(
    role => role.slug === OrganizationUserRoleSlugs.SUPER_ADMIN
  );

  const hasIntakeFormEntitlement = useOrganizationHasEntitlement(
    EntitlementSlugEnum.IntakeForm
  );
  const intakeFormDoesNotExist =
    isFetchBaseQueryError(error) && error.status === 404;

  const shouldRenderIntakeForm =
    showIntakeForm &&
    hasIntakeFormEntitlement &&
    intakeFormDoesNotExist &&
    isAdminRole;

  return {
    shouldRenderIntakeForm,
    intakeFormCompleted: !intakeFormDoesNotExist,
  };
};
